import styled from 'styled-components'
import nativeStyled from 'styled-components/native'
import { ProximaNova, ProximaNovaBold } from '../../App/Components'

export const MessageWrapper = nativeStyled.View`
  display: flex;
  justify-content: center;
  margin: 2em;
  padding: 1em;
  text-align: center;
`

export const MessageText = nativeStyled.Text`
  color: ${({ fontcolor }) => fontcolor};
  font-size: 13px;
`

export const MessageTextStrong = nativeStyled.Text`
  font-weight: bold;
`
export const FormHeading = nativeStyled.View`
  display: flex;
  flex-wrap: wrap;
  margin: 25px;
`

export const FormTitle = nativeStyled(ProximaNovaBold)<{ fontcolor: string }>`
  font-size: 20px;
  color: ${({ fontcolor }) => fontcolor};
`

export const FormDescription = nativeStyled(ProximaNova)<{ fontcolor: string }>`
  font-size: 13px;
  font-style: italic;
  color: ${({ fontcolor }) => fontcolor};
`

/**
 * OB-499: Native <button>. Was styled(TouchableOpacity).
 */
export const FormButton = styled.button<{
  highlight: string
  bgcolor: string
}>`
  justify-content: center;
  align-self: center;
  background-color: ${({ bgcolor }) => bgcolor};
  color: ${({ highlight }) => highlight};
  border-color: ${({ highlight }) => highlight};
  border-style: solid;
  border-width: 2px;
  text-align: center;
  padding: 10px 70px;
  border-radius: 30px;
  margin-top: 14px;
  margin-bottom: 28px;
  appearance: none;
  cursor: pointer;
  font: inherit;
  display: flex;
`

export const FormButtonText = nativeStyled(ProximaNova)<{
  highlight: string
}>`
  color: ${({ highlight }) => highlight};
  text-align: center;
`
